import './../../vendor/stickyfill'
;(() => {
  let screenWidth = document.documentElement.clientWidth
  let sharebar = document.querySelector('.editorial__social.sticky')

  if (sharebar && screenWidth >= 759) {
    Stickyfill.add(sharebar)
  } else if (sharebar) {
    sharebar.classList.remove('sticky')
  }

  let responsiveShareBehavior = event => {
    let screenWidth = document.documentElement.clientWidth
    if (sharebar && screenWidth <= 759) {
      Stickyfill.remove(sharebar)
      sharebar.classList.remove('sticky')
    } else {
      if (sharebar) {
        Stickyfill.add(sharebar)
        sharebar.classList.add('sticky')
      }
    }
  }

  window.addEventListener('resize', responsiveShareBehavior)
})()
